import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import HomeCom from "../../Home/HomeCom";
import AboutUsCom from "../../AboutUs/AboutUsCom";

export default function ComRoutes() {
    return (
        <Router>
            <Switch>
                <Route exact path="/" component={HomeCom} />
                <Route exact path="/aboutus" component={AboutUsCom} />
                <Redirect to="/" />
            </Switch>
        </Router>
    );
}

